<template>
  <header class="c-header">
    <a href="https://www.airasia.com/en/home.page?utm_medium=display&utm_source=jnto&utm_campaign=d7_au_ptmkt%7Cjnto%7C04062018%7Cau-en" class="c-header__logo" @click="$ga.event('SecretScrolls', 'Click', 'AirAsia Logo Top');" target="_blank"><img :src="`${baseUrl}img/airasia.svg`" alt="AirAsia"></a>
    <h1><span>The secret scrolls of</span>Ikigai</h1>
  </header>
</template>

<script>
export default {
  name: 'main-header',
};
</script>



// WEBPACK FOOTER //
// MainHeader.vue?429cd0b5